// Stable per-browser id, sent with signup so serial trial signups from one device are detectable.
const KEY = "videra.device.v1";

export const deviceId = () => {
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(KEY, v);
  }
  return v;
};
